import { create } from 'zustand';

type CursorKey = string;

type MiniTvCursorState = {
  cursorEventIdByKey: Record<CursorKey, string | null | undefined>;
  setCursorEventId: (key: CursorKey, eventId: string | number | null | undefined) => void;
  clearCursor: (key: CursorKey) => void;
  reset: () => void;
};

export function miniTvCursorKey(params: {
  scheduleId: string | number | null | undefined;
  week?: string | number | null | undefined;
}): CursorKey {
  const sid = params.scheduleId != null ? String(params.scheduleId) : 'none';
  const wk = params.week != null && String(params.week).trim() !== '' ? String(params.week) : '';
  return wk ? `${sid}:week:${wk}` : `${sid}:schedule`;
}

export const useMiniTvCursorStore = create<MiniTvCursorState>((set) => ({
  cursorEventIdByKey: {},

  setCursorEventId: (key, eventId) => {
    const next = eventId != null && String(eventId).trim() !== '' ? String(eventId).trim() : null;
    set((s) => ({
      cursorEventIdByKey: {
        ...s.cursorEventIdByKey,
        [String(key)]: next,
      },
    }));
  },

  clearCursor: (key) =>
    set((s) => {
      const next = { ...s.cursorEventIdByKey };
      delete next[String(key)];
      return { cursorEventIdByKey: next };
    }),

  reset: () => set({ cursorEventIdByKey: {} }),
}));

